import React from "react";
import FormInput from "../widgets/FormInput";
import { showSuccessToast } from "src/lib/utils";
import { Button } from "../ui/button";
import { useMutation } from "@tanstack/react-query";
import { updateProfile } from "src/api/settings";
import { usePortalContext } from "src/context/PortalContext";
import { Formik } from "formik";
import * as Yup from "yup";
import { useAuth } from "src/providers/AuthProvider";

const validationSchema = Yup.object().shape({
	first_name: Yup.string().required("This field is required"),
	last_name: Yup.string().required("This field is required"),
	phone: Yup.string().required("This field is required"),
});

const EditProfileModal = ({ user }) => {
	const closePortal = usePortalContext();
	const { setUser } = useAuth();

	const initialValues = {
		uuid: user?.uuid,
		first_name: user.first_name || "",
		last_name: user.last_name || "",
		phone: user.phone || "",
		image: null,
	};

	const { mutate, isLoading } = useMutation(updateProfile, {
		onSuccess: ({ message, data }) => {
			showSuccessToast(message);
			setUser(data);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit, setFieldValue }) => (
				<form onSubmit={handleSubmit} className="Modal-form">
					<FormInput
						className="formItem !tw-w-full"
						label="First Name"
						name="first_name"
						type="text"
						placeholder="First Name"
						value={values.first_name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full"
						label="Last Name"
						name="last_name"
						type="text"
						placeholder="Last Name"
						value={values.last_name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full"
						label="Contact"
						name="phone"
						type="text"
						placeholder="Contact"
						value={values.phone}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full"
						label="Profile Image"
						name="image"
						type="file"
						placeholder="Image"
						onChange={(event) => setFieldValue("image", event.currentTarget.files[0])}
					/>

					<Button className="tw-w-full" variant="secondary" disabled={isLoading}>
						{isLoading ? "Updating..." : "Update Profile"}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default EditProfileModal;
